import { envConfig } from '../env';

/** Absolute API URL in production; in dev empty → use relative `/api/...` (Vite proxy). */
export function apiUrl(path: string): string {
  const base = (envConfig.apiBaseUrl || '').replace(/\/$/, '');
  if (!base) return path.startsWith('/') ? path : `/${path}`;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
